/** @format */

import React from 'react';

import logo from '../../../images/img/logo.svg';
import SearchIcon from '../../../images/img/search.svg';
import Hamburger from '../../../images/img/hamburger.svg';

import AlertModal from './AlertModal';
import ShareModal from './ShareModal';
import { UseApp, ExtraMeetup } from 'components/UseApp';
import Menu from './Menu';
import MenuGroup from './Menu/MenuGroup';
import MenuItem from './Menu/MenuItem';
import Search from './Search';
import UserGroup from './UserGroup';
import Language from './Language';
import RightSidebar from './RightSidebar';
import { MDIconWrapper, MDIconImg, EmptyWrapper } from './styles';
import { useNavbar, navbarItems } from './useNavbar';

const Navbar = () => {
	const {
		size,
		MD,
		isXL,
		isLG,
		rightSidebar,
		isSearch,
		showUserGroup,
		gotoHomeOrRefresh,
		toggleSearch,
		toggleRightSidebar
	} = useNavbar();

	return (
		<>
			<div
				className="eatme-nav navbar"
				style={{ position: 'fixed', width: '100%' }}>
				<div className="eatme-nav-item">
					<div
						onClick={gotoHomeOrRefresh}
						style={{ cursor: 'pointer', height: '20px', marginTop: '10px' }}>
						<img src={logo} alt="" height="20" />
					</div>
					{isXL && (
						<div className="eatme-nav-item">
							<Search />
						</div>
					)}
					{size > MD && (
						<>
							{navbarItems.map((navbarItem) => {
								return (
									<div
										key={`navbar_${navbarItem.i18nKey}`}
										className="eatme-nav-item">
										<Menu i18nKey={navbarItem.i18nKey} path={navbarItem.path}>
											{navbarItem.group.map((groupItem) => {
												return (
													<MenuGroup
														key={`navbar_group_${groupItem.i18nKey}`}
														path={groupItem.path}
														i18nKey={groupItem.i18nKey}
														background="#FFE75C">
														{groupItem.items.map((item) => {
															return (
																<MenuItem
																	key={`navbar_item_${item.i18nKey}`}
																	i18nKey={item.i18nKey}
																	path={item.path}
																/>
															);
														})}
													</MenuGroup>
												);
											})}
										</Menu>
									</div>
								);
							})}
						</>
					)}
				</div>
				<div className="eatme-nav-end eatme-nav-item">
					{size > MD && <Language />}
					{size <= MD && (
						<MDIconWrapper>
							<div>
								<MDIconImg
									src={SearchIcon}
									width={20}
									height={20}
									onClick={toggleSearch}
								/>
							</div>
							<div>
								<MDIconImg
									src={Hamburger}
									width={20}
									height={20}
									onClick={() => toggleRightSidebar(true)}
								/>
							</div>
							{rightSidebar && <RightSidebar showUserGroup={showUserGroup} />}
						</MDIconWrapper>
					)}
					{showUserGroup && <UserGroup />}
				</div>
			</div>
			<EmptyWrapper />
			{((size <= MD && isSearch) || isLG) && <Search RWD={'MD'} />}
			<AlertModal />
			<ShareModal />
			<UseApp />
			<ExtraMeetup />
		</>
	);
};

export default React.memo(Navbar);
